/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
    ClockCircleOutlined,
    CloseOutlined,
    DownloadOutlined,
    ExclamationCircleOutlined,
    MoreOutlined,
} from '@ant-design/icons';
import { Drawer, Dropdown, Menu, Select, Tooltip } from 'antd';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DataFlowService from '../../../../services/DataFlow.service';
import DataBreachService from '../../../../services/DataBreach.service';
import RopaService from '../../../../services/Ropa.service';
import { useEffect, useState } from 'react';
import moment from 'moment';
import UserService from '../../../../services/UserService';
import ModalDelete from '../../../../components/Shared/modal/delete';
import useNotify from '../../../../context/Notification/useNotify';
import ModalFail from './../../../../components/Shared/modal/fail';
import { useNavigate } from 'react-router-dom';
import ModalReviewed from './components/ModalReviewed';
import ModalRevise from './components/ModalRevise';
import ModalActivity from '../ModalActivity';
import ModalSuccess from '../../../../components/Shared/modal/success';
import { STATUS_ID as STATUS } from '../../STATUS_ID';
import { ROUTER } from '../../../../constants/router';
import History from './History';
import usePermission from '../../../../hooks/usePermission';
import ModalChangeStatus from './components/ModalChangeStatus';

const { Option } = Select;

export default function Detail({
    detail,
    detailInfo,
    getRoPaDetailHeader,
    secretLevelId,
}) {
    const notify = useNotify();
    const { t, i18n } = useTranslation();
    const { activityId, menu } = useParams();

    // console.log({secretLevelId})

    // Role
    const role = UserService.role().toLowerCase();
    const admin = ['admin', 'auditor', 'super admin'].includes(role);
    const superAdmin = ['super admin'].includes(role);
    const userRole = ['user'].includes(role);
    const adminRole = ['admin'].includes(role);

    const { isAuditor } = usePermission();

    let navigate = useNavigate();
    // state
    const [statusList, setStatusList] = useState([]);
    const [visible, setVisible] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [openFail, setOpenFail] = useState(false);
    const [msg, setMsg] = useState('');
    const [openConfirm, setOpenConfirm] = useState(false);
    const [openConfirm2, setOpenConfirm2] = useState(false);
    const [openConfirm3, setOpenConfirm3] = useState(false);
    const [status, setStatus] = useState('');
    const [loading, setLoading] = useState(false);
    const [openActivityModal, setOpenActivityModal] = useState(false);
    const [openSuccess, setOpenSuccess] = useState(false);
    const [isChangeStatus, setIsChangeStatus] = useState(true);
    const [userOptions, setUserOptions] = useState([]);
    const [currentUser, setCurrentUser] = useState();
    const [roleUser, setRoleUser] = useState();

    const menu_list = (
        <Menu
            items={[
                {
                    label: (
                        <button
                            onClick={() => {
                                setOpenActivityModal(true);
                            }}
                        >
                            {t('common.Edit')}
                        </button>
                    ),
                },
                {
                    label: (
                        <button
                            onClick={() => {
                                setOpenDelete(true);
                            }}
                        >
                            {t('common.Delete')}
                        </button>
                    ),
                },
            ]}
        />
    );

    const menu_wait = (
        <Menu
            items={[
                {
                    label: (
                        <span
                            onClick={() => {
                                setOpenActivityModal(true);
                            }}
                        >
                            {t('common.Edit')}
                        </span>
                    ),
                },
            ]}
        />
    );

    const switchMenu =
        admin && detailInfo?.statusId === STATUS.WAITING_FOR_REVIEW
            ? menu_wait
            : menu_list;

    const deleteActivity = async (id) => {
        await RopaService.deleteActivity(id)
            .then((res) => {
                if (res?.data?.errorData) {
                    if (res?.data?.errorData?.code === 400) {
                        setOpenFail(true);
                        setMsg(res?.data?.errorData?.msg);
                    }
                } else {
                    notify({
                        title: t('common.Success'),
                        description: t('Successfully deleted data'),
                    });
                    setTimeout(() => {
                        navigate(ROUTER.DS_INVENTORY.ROPA);
                    }, 2500);
                }
            })
            .catch((err) => {
                setOpenFail(true);
                setMsg(t('common.FailedDeleteData'));
            });
    };

    const isDisabled = () => {
        if (isAuditor) return true;

        if (detail) {
            const {
                categoryPersonalData,
                collectData,
                collectDataDestruction,
                referenceDocuments,
            } = detail;
            if (
                categoryPersonalData &&
                collectData &&
                collectDataDestruction &&
                referenceDocuments.length > 0 &&
                secretLevelId
            ) {
                return false;
            } else {
                return true;
            }
        } else {
            return true;
        }
    };

    const getStatus = async () => {
        try {
            const { data } = await DataFlowService.getStatus({
                type: 'ropa-activity',
            });
            let status = [];
            if (data?.resultData) {
                if (!admin) {
                    // role user
                    // draft
                    if (detailInfo?.statusId === STATUS.DRAFT) {
                        const _case = [STATUS.DRAFT, STATUS.WAITING_FOR_REVIEW];
                        const _status = data?.resultData.filter((result) =>
                            _case.includes(result.statusId)
                        );
                        status.push(..._status);
                    } else if (detailInfo?.statusId === STATUS.REVISE) {
                        // Revive
                        const _case = [
                            STATUS.REVISE,
                            STATUS.WAITING_FOR_REVIEW,
                        ];
                        const _status = data?.resultData.filter((result) =>
                            _case.includes(result.statusId)
                        );

                        status.push(..._status);
                    } else {
                        status = data?.resultData;
                    }
                } else {
                    // role admin
                    // รอตรวจสอบ
                    if (
                        detailInfo?.statusId === STATUS.WAITING_FOR_REVIEW ||
                        detailInfo?.statusId === STATUS.REVIEWED
                    ) {
                        const _case = [
                            STATUS.WAITING_FOR_REVIEW,
                            STATUS.REVIEWED,
                            STATUS.REVISE,
                        ];
                        const _status = data?.resultData.filter((result) =>
                            _case.includes(result.statusId)
                        );
                        status.push(..._status);
                    } else if (detailInfo?.statusId === STATUS.DRAFT) {
                        const _case = [STATUS.DRAFT, STATUS.WAITING_FOR_REVIEW];
                        const _status = data?.resultData.filter((result) =>
                            _case.includes(result.statusId)
                        );
                        status.push(..._status);
                    } else if (detailInfo?.statusId === STATUS.REVISE) {
                        // Revive
                        const _case = [
                            STATUS.REVISE,
                            STATUS.WAITING_FOR_REVIEW,
                        ];
                        const _status = data?.resultData.filter((result) =>
                            _case.includes(result.statusId)
                        );

                        status.push(..._status);
                    } else {
                        status = data?.resultData;
                    }
                }
                setStatusList(status);
            }
        } catch (err) {
            console.log(err);
        }
    };

    const getUserOptions = async () => {
        try {
            const { data } = await DataBreachService.getUserList();
            if (data?.resultData) {
                setUserOptions(data?.resultData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getUserId = async () => {
        try {
            const user = UserService.getUi();
            if (user) {
                setCurrentUser(user);
            }
        } catch (err) {
            console.log(err);
        }
    };
    const getRole = async () => {
        try {
            const role = UserService.role();
            if (role) {
                setRoleUser(role);
            }
        } catch (err) {
            console.log(err);
        }
    };
    useEffect(() => {
        if (detailInfo) getStatus();
        getUserOptions();
        getUserId();
        getRole();
    }, [activityId, detailInfo]);

    useEffect(() => {
        if (!openActivityModal) {
            getRoPaDetailHeader();
        }
    }, [openActivityModal]);

    const handelReviewerOk = async (userId) => {
        const payload = {
            activityId,
            status,
            lastReviewDate: null,
            nextReviewDue: null,
            reason: '',
            reviewer: userId,
        };
        setLoading(true);
        try {
            const { data } = await RopaService.changeStatusRopa(payload);
            if (data.resultCode === 1) {
                notify({
                    title: t('common.Success'),
                    description: t('Successfully save data'),
                });
                getRoPaDetailHeader();
                setLoading(false);
                setOpenConfirm(false);
                setIsChangeStatus(true);
                navigate(`${ROUTER.DS_INVENTORY.ROPA}/${activityId}/view`);
            } else {
                setLoading(false);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to submitted'),
                });
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('Failed to submitted'),
            });
        }
    };
    const onChange = (value) => {
        if (value === STATUS.DRAFT) {
            setOpenConfirm(true);
            setStatus(STATUS.DRAFT);
        }
        if (value === STATUS.REVISE) {
            setOpenConfirm3(true);
            setStatus(STATUS.REVISE);
        }
        if (value === STATUS.WAITING_FOR_REVIEW) {
            setOpenConfirm(true);
            setStatus(STATUS.WAITING_FOR_REVIEW);
        }
        if (value === STATUS.REVIEWED) {
            setOpenConfirm2(true);
            setStatus(STATUS.REVIEWED);
        }
    };

    const checkStatus = () => {
        if (menu) {
            return true;
        } else {
            if (!admin) {
                if (detailInfo?.statusId === STATUS.WAITING_FOR_REVIEW) {
                    return true;
                }
                if (detailInfo?.statusId === STATUS.REVIEWED) {
                    return true;
                }
            } else {
                return false;
            }
        }
    };

    const checkPermission = () => {
        if (detailInfo?.statusId === STATUS.WAITING_FOR_REVIEW) {
            if (superAdmin) {
                return true;
            } else {
                if (detailInfo?.reviewer) {
                    if (currentUser !== detailInfo?.reviewer) {
                        return false;
                    } else {
                        return true;
                    }
                } else {
                    return true;
                }
            }
        } else {
            return true;
        }
    };

    const checkMore = () => {
        if (isAuditor) return true;
        if (!admin) {
            if (
                detailInfo?.statusId === STATUS.REVIEWED ||
                detailInfo?.statusId === STATUS.WAITING_FOR_REVIEW
            ) {
                return true;
            } else {
                return false;
            }
        } else {
            if (detailInfo?.statusId === STATUS.REVIEWED) {
                return true;
            } else {
                return false;
            }
        }
    };

    const exportListActivity = (id) => {
        setTimeout(async () => {
            try {
                const select = [];
                select.push(id);
                const res = await RopaService.exportListActivity({
                    activityIds: select,
                    isAll: false,
                });
                const objectURL = window.URL.createObjectURL(
                    new Blob([res?.data])
                );
                const link = document.createElement('a');
                link.href = objectURL;
                link.download = `ropa_report_export${moment(new Date()).format(
                    '_DDMMYYYYhhmmss'
                )}.xlsx`;
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            } catch (error) {
                console.log(error);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('RoPA.FailedToDownloaded'),
                });
            }
        }, 1200);
    };

    return (
        <div className="bg-white w-full p-4 pb-8 rounded-xl">
            <div
                className="text-xl font-medium text-purple pb-2 flex justify-between"
                style={{ borderBottom: '3px solid #F4F6FC' }}
            >
                {!menu && checkPermission() ? (
                    <div>
                        <Dropdown
                            placement="bottomLeft"
                            arrow
                            overlay={switchMenu}
                        >
                            <button
                                hidden={checkMore()}
                                className="w-8 h-8 bg-gray-100 px-2 rounded-lg mr-4"
                            >
                                <MoreOutlined className="rotate-90" />
                            </button>
                        </Dropdown>
                        {detailInfo?.activityName || '-'}
                    </div>
                ) : (
                    <p className="mb-0">{detailInfo?.activityName || '-'}</p>
                )}
                {/* History */}
                <div className="flex space-x-4 items-center">
                    <span className="text-xs text-[#65707A]">
                        {t('Version')}: {detailInfo?.version || '-'}
                    </span>
                    <button
                        onClick={() => {
                            setVisible(true);
                            setIsChangeStatus(true);
                        }}
                        className="bg-[#F3F6F9] h-8 w-8 flex items-center justify-center rounded-lg text-purple text-sm"
                    >
                        <ClockCircleOutlined />
                    </button>
                    {!menu && (
                        <button
                            onClick={() => {
                                exportListActivity(detailInfo?.activityId);
                            }}
                            className="bg-[#F3F6F9] h-8 w-8 flex items-center justify-center rounded-lg text-purple text-lg"
                        >
                            <DownloadOutlined />
                        </button>
                    )}

                    <Drawer
                        width={460}
                        title={
                            <div className="flex justify-between items-center">
                                <span className="text-purple text-[17px]">
                                    {t('History')}
                                </span>
                                <button
                                    onClick={(e) => setVisible(false)}
                                    className="bg-[#F3F6F9] h-8 w-8 flex items-center justify-center rounded-lg text-purple text-sm font-semibold"
                                >
                                    <CloseOutlined />
                                </button>
                            </div>
                        }
                        placement="right"
                        onClose={() => setVisible(false)}
                        closable={false}
                        open={visible}
                        className="history"
                    >
                        <History
                            setIsChangeStatus={setIsChangeStatus}
                            isChangeStatus={isChangeStatus}
                        />
                    </Drawer>
                </div>
            </div>
            <div className="mt-4">
                <div className="mb-2">
                    <span className="font-semibold ">
                        {t('This activity is under the task')} :{' '}
                        {detailInfo?.businessProcessName}{' '}
                    </span>
                    - {detailInfo?.businessProcessFullName || '-'}
                </div>
                <div className="grid lg:grid-cols-3 gap-4">
                    <div className="grid grid-cols-2 items-center">
                        <div className="font-semibold">
                            {t('RoPA.BusinessProcess')} :
                        </div>
                        <div>{detailInfo?.businessProcessName || '-'}</div>
                    </div>
                    <div className="grid grid-cols-2 items-center">
                        <div className="font-semibold">
                            {t('RoPA.Reviewer')} :
                        </div>
                        <div>{detailInfo?.reviewBy || '-'}</div>
                    </div>
                    <div className="grid grid-cols-2 items-center">
                        <div className="font-semibold">{t('Status')} :</div>
                        <div className="flex space-x-2 items-center">
                            {statusList.length > 0 && (
                                <>
                                    <Select
                                        disabled={
                                            isDisabled() ||
                                            checkStatus() ||
                                            !checkPermission()
                                        }
                                        value={detailInfo?.statusId}
                                        size="large"
                                        style={{ width: '100%' }}
                                        onChange={onChange}
                                    >
                                        {statusList?.map((status) => (
                                            <Option
                                                key={status?.statusId}
                                                value={status?.statusId}
                                            >
                                                {i18n.language === 'en'
                                                    ? status?.nameEn
                                                    : status?.nameTh}
                                            </Option>
                                        ))}
                                    </Select>

                                    {isDisabled() && (
                                        <Tooltip
                                            placement="bottomRight"
                                            title={t(
                                                'dataFlow.PleaseSpecifyAllInformation'
                                            )}
                                        >
                                            <button className="bg-purple-light p-2 flex items-center justify-center rounded-lg text-purple">
                                                <ExclamationCircleOutlined />
                                            </button>
                                        </Tooltip>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                    <div className="space-y-6">
                        <div className="grid grid-cols-2 items-center">
                            <div className="font-semibold">
                                {t('RoPA.Department')} :
                            </div>
                            <div>
                                {i18n.language === 'en'
                                    ? detailInfo?.departmentEn
                                    : detailInfo?.departmentTh || '-'}
                            </div>
                        </div>
                        <div className="grid grid-cols-2">
                            <div className="font-semibold">
                                {t('RoPA.Purpose')} :
                            </div>
                            <div>{detailInfo?.purposeName || '-'}</div>
                        </div>
                    </div>
                    <div className="space-y-6">
                        <div className="grid grid-cols-2">
                            <div className="font-semibold">
                                {t('RoPA.ReviewedDate')} :
                            </div>
                            <div>
                                {detailInfo?.reviewDate
                                    ? moment(detailInfo?.reviewDate).format(
                                          'DD/MM/YYYY HH:mm'
                                      )
                                    : '-'}
                            </div>
                        </div>
                        <div className="grid grid-cols-2">
                            <div className="font-semibold">
                                {t('RoPA.NextReviewDue')} :
                            </div>
                            <div>
                                {detailInfo?.nextReviewDue
                                    ? moment(detailInfo?.nextReviewDue).format(
                                          'DD/MM/YYYY HH:mm'
                                      )
                                    : '-'}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <ModalConfirm
                loading={loading}
                text={`${t('Do you want to confirm')} <br /> “${
                    detailInfo?.activityName || '-'
                }” ?`}
                open={openConfirm}
                handelOk={() => handelOk()}
                handelClose={() => setOpenConfirm(false)}
            /> */}
            <ModalChangeStatus
                loading={loading}
                open={openConfirm}
                handelClose={() => setOpenConfirm(false)}
                userOptions={userOptions}
                handelReviewerOk={handelReviewerOk}
            />
            <ModalReviewed
                status={status}
                getRoPaDetailHeader={getRoPaDetailHeader}
                open={openConfirm2}
                handelClose={() => setOpenConfirm2(false)}
                setIsChangeStatus={setIsChangeStatus}
            />
            <ModalRevise
                status={status}
                getRoPaDetailHeader={getRoPaDetailHeader}
                open={openConfirm3}
                handelClose={() => setOpenConfirm3(false)}
                setIsChangeStatus={setIsChangeStatus}
            />

            <ModalFail
                text={msg}
                open={openFail}
                handelClose={() => setOpenFail(false)}
            />
            <ModalDelete
                open={openDelete}
                text={t('modalActivityDelete')}
                handelOk={() => {
                    deleteActivity(activityId);
                    setOpenDelete(false);
                }}
                handelClose={() => setOpenDelete(false)}
            />

            <ModalActivity
                mode="editActivity"
                open={openActivityModal}
                setOpenSuccess={setOpenSuccess}
                detailInfo={detailInfo}
                handelClose={() => {
                    setOpenActivityModal(false);
                }}
            />

            <ModalSuccess
                open={openSuccess}
                text={t('RoPA.SuccessfullyUpdateData')}
                handelClose={() => setOpenSuccess(false)}
            />
        </div>
    );
}
